<template>
	<component :is="props.is" class="btn" :class="`btn--${color} btn--${size}`">
		<slot></slot>
	</component>
</template>
<script lang="ts" setup>
import "./Button.scss";

interface Props {
	is? : any,
	color : 'brand' | 'light' | 'dark' | 'red-transparent' | 'brand-transparent'
	size? : 'big' | 'normal' | 'small'
}

let props = withDefaults(defineProps<Props>(), {
	is : 'button',
	size : 'normal'
});
</script>